import ajaxUtils from "./ajaxutils";
import wsUtils from "./wsUtils";
import utils from "./utils";
import shelltool from "./shelltool";

const public_path = "https://static.h5bqb.top/static/images/";
const warning_icon = `${public_path}warning_icon.png`;
const loading_status = `${public_path}loading_status.gif`;
const file_icon = `${public_path}file_icon.svg`;
const pic_uploading = `${public_path}pic_uploading.png`;
const video_bg = `${public_path}video_bg.png`;

window.addEventListener("offline", (e) => {
  const sysMsg = {
    msgtype: "system",
    content: "网络连接已断开，请检查网络！",
    mid: "native_" + new Date().getTime(),
  };
  showMoreMessage(sysMsg, true);
});

const getReadableMsgTime = (msgTime) => {
  if (msgTime) {
    msgTime = msgTime.replace(/-/g, "/");
    let msgYear = new Date(msgTime).getFullYear();
    let curYear = new Date().getFullYear();
    if (msgYear < curYear) {
      return msgTime;
    } else {
      return msgTime.slice(5);
    }
  } else {
    return "";
  }
};

const getMessageStatusImg = (msg, flag) => {
  if (!flag || !msg.result) {
    return "";
  }
  return `<img id="${msg.ackid}_status" title="正在发送..."class="message-status" src="${loading_status}"/>`;
};

const getFileTarget = (data) => {
  const contentHtml = `<img class="file-icon" src="${file_icon}" />
                    <div class="file-title single-line" style={{ width:'165px', whiteSpace:'nowrap'}}>${utils.truncateFileName(data.title, 185)}</div>
                    <div class="file-size">${utils.formatStorageSize(
                      data.size
                    )}</div>`;
  return data.content
    ? `<a href="${data.content}" target="_blank" class="inner-card">${contentHtml}</a>`
    : `<div class="inner-card">${contentHtml}</div>`;
};

const resolveVideoConfig = (msg) => {
  const result = { height: msg.height, width: msg.width };
  if (result.height > 180) {
    result.width = (180 * result.width) / result.height;
    result.height = 180;
  }
  if (result.width > 240) {
    result.height = (240 * result.height) / result.width;
    result.width = 240;
  }
  return result;
}

window.showImage = (event) => {
  shelltool.postMessage({ type: "largeImg", data: { url: event.target.src } });
};

window.showVideo = (event) => {
  event.stopPropagation();
  const targetSrc = event.target.dataset.src;
  if(targetSrc && targetSrc.indexOf('https://cdn.wykefu.com/') == -1) {
    return;
  }

  shelltool.postMessage({ type: "previewVideo", data: { url: targetSrc } });
};

const createMessageHtml = (data, params) => {
  params = params || {};
  const rightMsg = params.rightMessage || data.uid == data.from_uid;
  const statusSending = getMessageStatusImg(data, rightMsg);
  const htmlId = data.mid ? "mid_" + data.mid : data.ackid;
  let msgContent = "";

  switch (data.msgtype) {
    case "system": {
      if (params.createNode) {
        const messageItem = document.createElement("div");
        messageItem.className = "message-tag";
        messageItem.innerHTML = `<div class="content">${getReadableMsgTime(
          data.ctime
        )} ${data.content}</div>`;
        return messageItem;
      }
      return `<div class="message-tag">
                <div class="content">${getReadableMsgTime(data.ctime)} ${
        data.content
      }</div>
              </div>`;
    }
    case "emotion":
    case "image": {
      msgContent = `<div class="message-img">
            ${statusSending}
            <img id="${htmlId}_img" class="msg-img link-style" onclick="showImage(event)" src="${data.content}" />
            </div>`;
      break;
    }
    case "file": {
      msgContent = `<div class="inner-card-outer" id="${htmlId}_outer">
                ${statusSending}
                ${getFileTarget(data)}
            </div>`;
      break;
    }
    case "video": {
      const { height, width } = resolveVideoConfig(data);
      const duration = Math.ceil(data.duration || 0);
      const result = duration % 60;
      msgContent = `<div id="${htmlId}_video" class="message-video message-img" onclick="showVideo(event)" data-src="${data.content}" style="width:${width}px; height:${height}px; background-image: url(${data.thumb}); background-size: cover;">
            ${statusSending}
            <div class="video-play-btn" id="${htmlId}_video_btn" style="opacity:${data.content ? 1 : 0}" onclick="showVideo(event)" data-src="${data.content}"></div>
            <div class="v-duration" id="${htmlId}_video_duration">${parseInt(duration / 60) + (result < 10 ? `:0${result}` : `:${result}`)}</div>
            </div>`;
      break;
    }
    case "link": {
      msgContent = `<div class="inner-card-outer" id="${htmlId}_outer">
              <a href=${data.thumb_url} target="_blank" class="inner-card">
                <div class="content-img" style="background-image: url(${data.content})"></div>
                <div class="content-title">${data.title}</div>
                <div class="content-des">${data.description}</div>
                </a>
            </div>`;
      break;
    }
    default: {
      let RMsg = utils.linkifyText(utils.replaceTag(data.content));
      let LMsg = utils.linkifyText(data.content.indexOf('<') > -1 && data.content.indexOf('>') > -1 ? utils.replaceSpecialTag(data.content) : data.content);
      const emotionParsedRContent = qqWechatEmotionParser(RMsg);
      const emotionParsedLContent = qqWechatEmotionParser(LMsg);
      msgContent = `
        <span class="message-text">
          ${statusSending}
          <pre>${rightMsg ? emotionParsedRContent : emotionParsedLContent}</pre>
        </span>
      `;
      break;
    }
  }
  let fromName = data.from_name || "";
  if (!rightMsg && loginData.kefu_name_from) {
    fromName = loginData.kefu_name_from;
  }
  if (params.createNode) {
    const messageItem = document.createElement("div");
    messageItem.id = htmlId;
    messageItem.className = `message-item${rightMsg ? " message-right" : ""}`;
    messageItem.innerHTML = `<div class="name">${fromName} ${getReadableMsgTime(
      data.ctime
    )}</div>
        ${msgContent}
        <div class="clear-both"></div>`;
    return messageItem;
  }
  return `<div class="message-item${
    rightMsg ? " message-right" : ""
  }"  id="${htmlId}">
        <div class="name">${fromName} ${getReadableMsgTime(data.ctime)}</div>
        ${msgContent}
        <div class="clear-both"></div>
        </div>`;
};

const requestMessageList = (history, cb) => {
  const params = { token: loginData.token };
  let historyElement;
  if (history) {
    historyElement = document.getElementById("more-history");
    historyElement.children[0].style.display = "none";
    historyElement.children[1].style.display = "block";
    params.forward = 1;
    params.mid = lastMid;
  }
  params.version = "0.0.9";
  ajaxUtils.httpRequest({
    url: "/wykf/api/v1/enterprise/webplugin/message",
    data: params,
    success: (result) => {
      const msg = result.data.msg;
      messageLength += msg.length;
      msg.length && (lastMid = msg[0].mid);
      const resultHtml = msg.map((item) => createMessageHtml(item));
      if (history) {
        const node = document.getElementById("msg-wrapper");
        const newNode = document.createElement("div");
        newNode.innerHTML = resultHtml.join("");
        node.insertBefore(newNode, node.childNodes[1]);
        if (msg.length < 10) {
          historyElement.innerHTML = '<div class="content">没有更多了！</div>';
          setTimeout(() => {
            historyElement[
              utils.IsIE || utils.IsIE11 ? "removeNode" : "remove"
            ](true);
          }, 800);
        } else {
          historyElement.children[0].style.display = "block";
          historyElement.children[1].style.display = "none";
        }
      } else {
        document.getElementById("msg-wrapper").innerHTML =
          (msg.length < 10
            ? ""
            : '<div id="more-history"><div onclick="requestMessageList(1)" class="content">加载更多历史消息</div><div style="display: none;" class="content">加载中...</div></div>') +
          resultHtml.join("");
        utils.scrollDownEnd();
        window.requestHis = true;
        cb && cb(1)
        if(!history && !cb){ // FIXME 10003或网络重连情况下onopen内触发
            const sysMsg = {
              msgtype: "system",
              content: "连接已恢复！",
              mid: "native_" + new Date().getTime(),
            };
          showMoreMessage(sysMsg, true);
        }
      }
    },
    error: () => {
      if (history) {
        historyElement.children[0].style.display = "block";
        historyElement.children[1].style.display = "none";
      }
    },
  });
};

window.requestMessageList = requestMessageList;

const initEmojiFunction = () => {
  document.getElementById("emoji-btn").onclick = function () {
    let emojiDialog = document.getElementById("emoji-dialog");
    if (emojiDialog) {
      emojiDialog.style.display = "block";
    } else {
      emojiDialog = document.createElement("div");
      emojiDialog.id = "emoji-dialog";
      emojiDialog.innerHTML = `<div class="qq-emo-c" style="width:${
        utils.IsPcMode ? "440px" : "95%"
      }">
                ${window._qqWechatEmotionParser.emotion_map
                  .map((item, index) =>
                    item
                      .map(
                        (
                          cItem,
                          cIndex
                        ) => `<img class="wx-emo-img link-style" style="background-position: ${
                          -28 * cIndex
                        }px ${-28 * index}px"
                                    src="https://wx.qq.com/zh_CN/htmledition/v2/images/spacer.gif"
                                    alt="${cItem.cn}" />`
                      )
                      .join("")
                  )
                  .join("")}
            </div>`;

      emojiDialog.onclick = (event) => {
        if (event.target.className == "qq-emo-c") {
          return;
        }
        const element = document.getElementById("textarea");
        const newValue = event.target.alt;
        emojiDialog.style.display = "none";
        if (!newValue) {
          return;
        }
        let start = element.selectionStart;
        element.value =
          element.value.slice(0, start) + newValue + element.value.slice(start);
        start += newValue.length;
        element.focus();
        element.setSelectionRange(start, start);
      };
      document.body.appendChild(emojiDialog);
    }
  };
};

const sendMessage = (nextItem, sendCount) => {
  wsUtils.startProcess("sendMsgH", {
    message: nextItem,
    sendCount,
    cb: (status, data = {}, sendCount) => {
      if (status < 0) {
        if (sendCount < 4) {
          if (data.errcode === 10003) {
            startProcess({ errcode: data.errcode, token: data.token });
            setTimeout(() => {
              // FIXME 此处等待3秒待处理成实时获取ws_reconnect_suc的状态
              delete nextItem.ctime;
              delete nextItem.result;
              sendMessage(nextItem, sendCount);
            }, 3000);
            return;
          }
          setTimeout(() => {
            delete nextItem.ctime;
            delete nextItem.result;
            sendMessage(nextItem, sendCount);
          }, 1000);
        }
        const node = document.getElementById(nextItem.ackid + "_status");
        node.setAttribute("src", warning_icon);
        node.title = "消息发送失败，点击重新发送";
        node.onclick = function () {
          node.setAttribute("src", loading_status);
          node.title = "发送中...";
          setTimeout(() => {
            sendMessage(nextItem, 1);
          }, 1000);
        };
      } else {
        data.mid &&
          (document.getElementById(nextItem.ackid).id = "mid_" + data.mid);
        if (nextItem.msgtype == "file") {
          delete nextItem.result;
          document.getElementById(nextItem.ackid + "_outer").innerHTML =
            getFileTarget(nextItem);
        } else {
          document
            .getElementById(nextItem.ackid + "_status")
            [utils.IsIE || utils.IsIE11 ? "removeNode" : "remove"](true);
          if (
            urlParams.channel_id == "5ee1ff983dbf994471042f38" &&
            nextItem.msgtype === "text" &&
            data.content &&
            data.content != ""
          ) {
            //针对企微线上渠道优先展示后端返回的数据
            const parent = document.getElementById(
              "mid_" + data.mid
            ).childNodes;
            for (let i = 0; i < parent.length; i++) {
              if (parent[i].className === "message-text") {
                const childs = parent[i].childNodes;
                for (let j = 0; j < childs.length; j++) {
                  if (childs[j].nodeName == "PRE") {
                    childs[j].innerHTML = utils.linkifyText(utils.replaceSpecialTag(data.content));
                  }
                }
              }
            }
          }
        }
      }
    },
  });
};

const showMoreMessage = (nextItem, noRight) => {
  const date = new Date();
  nextItem.ctime = utils.formatDate(date);
  nextItem.result = date.getTime();
  if(nextItem.msgtype == 'video' && nextItem.width == 0 && !nextItem.content) {
    nextItem.thumb = video_bg
  }
  document
    .getElementById("msg-wrapper")
    .appendChild(
      createMessageHtml(nextItem, { rightMessage: !noRight, createNode: true })
    );
  utils.scrollDownEnd();
};

const resolveFileInput = (
  event,
  files,
  nextItem,
  fileType,
  base64,
  showMore
) => {
  !showMore && !nextItem.thumb && showMoreMessage(nextItem);
  ajaxUtils.changeInputImg(
    loginData.token,
    files,
    base64,
    nextItem,
    (status, data) => {
      if (!status && data.cdn_url) {
        nextItem.content = data.cdn_url;
        if(data.thumb) nextItem.thumb = data.thumb;
        if(data.duration) nextItem.duration = data.duration;
        if(data.fsize) nextItem.size = data.fsize;
        if (fileType) {
          nextItem.size = data.fsize;
          nextItem.title = data.filename;
        } else {
          if(data.width && data.height){ //获取宽高渲染
            nextItem.height = data.height;
            nextItem.width = data.width;
            if(nextItem.msgtype == 'video'){
              const ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
              if(ele_btn) {
                ele_btn.style.opacity = 1
              }
            }
          }
          if(nextItem.thumb) {
            if(data.cdn_url){ //获取视频内容渲染
              const ele = document.getElementById(nextItem.ackid + "_video");
              ele && ele.setAttribute("data-src", nextItem.content);
              const ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
              ele_btn && ele_btn.setAttribute("data-src", nextItem.content);
            }
            if(data.thumb){ //获取封面渲染
              const ele = document.getElementById(nextItem.ackid + "_video");
              const { height, width } = resolveVideoConfig(data);
              if(ele){
                ele.style.backgroundImage = `url("${nextItem.thumb}")`;
                ele.style.width = `${width}px`;
                ele.style.height = `${height}px`;
              }
            }
            if(data.duration){ //获取时长渲染
              const duration = data.duration || 0;
              const result = duration % 60;
              const ele_duration = document.getElementById(nextItem.ackid + "_video_duration");
              if(ele_duration){
                ele_duration.innerText = parseInt(duration / 60) + (result < 10 ? `:0${result}` : `:${result}`)
              }
            }
          }else{
            const ele = document.getElementById(nextItem.ackid + "_img");
            ele && ele.setAttribute("src", nextItem.content);
          }
        }
        sendMessage(nextItem, 1);
      }
      if (status) {
        if (data.errcode === 10003) {
          startProcess({ errcode: data.errcode, token: data.token });
          setTimeout(() => {
            delete nextItem.ctime;
            delete nextItem.result;
            resolveFileInput(event, files, nextItem, fileType, base64, true);
          }, 3000);
          return;
        }
        let content = '';
        if (data.errcode === -1 || data.errcode === 600){
          content = data.msg
        }else{
          content = `上传失败，请刷新重试 ${data.errcode ? `（${data.errcode}）` : ''}`;
        }
        const sysMsg = {
          msgtype: "system",
          content,
          mid: "native_" + new Date().getTime(),
        };
        showMoreMessage(sysMsg, true);
        const node = document.getElementById(nextItem.ackid + "_status");
        node.setAttribute("src", warning_icon);
        node.title = "发送失败";
        messageLength++;
      }
      event.target.value = "";
    }
  );
};

const resolveVideoBgImage = (files, nextItem, videoEvent, videoFile) => {
  ajaxUtils.changeInputImg(
    loginData.token,
    files,
    undefined,
    undefined,
    (status, data) => {
      if (!status && data.cdn_url) {
        nextItem.thumb = data.cdn_url; //封面图
        data.cdn_url && nextItem.thumb && showMoreMessage(nextItem);
        if(nextItem.msgtype == 'video'){
          const ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
          if(ele_btn) {
            ele_btn.style.opacity = 1
          }
        }
        resolveFileInput(videoEvent, videoFile, nextItem);
      }
      if (status) {
        if (data.errcode === 10003) { // 重新登录
          startProcess({ errcode: data.errcode, token: data.token });
          return;
        }
        //上传失败弹出失败系统提示
        let content = '';
        if (data.errcode === -1 || data.errcode === 600){
          content = data.msg
        }else{
          content = `上传失败，请刷新重试 ${data.errcode ? `（${data.errcode}）` : ''}`;
        }
        const sysMsg = {
          msgtype: "system",
          content,
          mid: "native_" + new Date().getTime(),
        };
        showMoreMessage(sysMsg, true);
      }
    }
  );
};

const initActions = () => {
  document.getElementById("send-btn").onclick = function () {
    sendTextArea();
  };
  const sendTextArea = () => {
    const element = document.getElementById("textarea");
    const message = element.value.trim();
    if (!message) {
      return;
    }
    const msgVal = utils.hasSensitiveWords(message)
    if(msgVal){
      const sysMsg = {
        msgtype: "system",
        content: "发送消息中包含敏感内容，请编辑后重试。",
        mid: "native_" + new Date().getTime(),
      };
      showMoreMessage(sysMsg, true);
      return
    }
    element.value = "";
    const nextItem = {
      content: utils.replaceTag(message),
      msgtype: "text",
      ackid: "msg_" + messageLength++,
    };
    sendMessage(nextItem, 1);
    showMoreMessage(nextItem);
  };
  const removeEventListeners = (videoElement) => {
    videoElement.removeEventListener('loadedmetadata', undefined);
    videoElement.removeEventListener('seeked', undefined);
  };
  const handleVideoBg = (file, event, files) =>{
    const videoElement = document.getElementById('video-preview');
    let videoDuration = 0, videoThumb = '', videoWidth = 0, videoHeight = 0, hasLogged = false, isProcessing = false;
   
    videoElement.src = URL.createObjectURL(file);
    videoElement.autoplay = true;
    videoElement.muted = true;

    videoElement.addEventListener('loadedmetadata', function() {
      if (isProcessing) return; // 如果已经在处理中，则直接返回
      isProcessing = true; // 标记为正在处理

      videoWidth = this.videoWidth;
      videoHeight = this.videoHeight;
      videoDuration = Math.floor(this.duration);

      if(!videoWidth && !videoHeight) {
        console.error('无法获取视频尺寸，终止上传');
        resolveFileInput(
          event,
          files,
          {
            msgtype: "file",
            title: file.name,
            size: file.size,
            ackid: "msg_" + messageLength++,
          },
          true
        );
        URL.revokeObjectURL(videoElement.src);
        videoElement.src = ''; // 清除视频源
        removeEventListeners(videoElement); // 移除所有事件监听器
        return;
      }
      videoElement.currentTime = 0;
      videoElement.play();
    });
    
    videoElement.addEventListener('seeked', function() {
      if (hasLogged || !videoWidth || !videoHeight) return;
      const canvas = document.createElement('canvas');
      canvas.width = videoWidth;
      canvas.height = videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      videoThumb = canvas.toDataURL('image/png'); // base64
      hasLogged = true; // 设置标志变量为 true，表示已经打印过日志
      videoElement.pause();
      const fileObject = utils.base64ToFile(videoThumb, `video_bg_${new Date().getTime()}`);
      const nextItem = {
        msgtype: "video",
        content: '',
        thumb: pic_uploading, //视频封面
        width: videoWidth, //视频宽
        height: videoHeight, // 视频高
        duration: videoDuration, // 时长
        size: file.size, // 文件的大小
        ackid: "msg_" + messageLength++,
      }
      resolveVideoBgImage([fileObject], nextItem, event, files); // 上传视频封面
      URL.revokeObjectURL(videoElement.src);
      removeEventListeners(videoElement); // 移除所有事件监听器
    });

    videoElement.load();
  };
  const resolveSend = (event) => {
    const files = event.target.files;
    const file = files[0];
    
    if(utils.isImageFile(file.name)){
      resolveFileInput(event, files, {
        content: pic_uploading,
        msgtype: "image",
        ackid: "msg_" + messageLength++,
      });
    }else if(utils.isVideoFile(file.name)){
      // 处理视频发送
      if (file) {
        if(file.size > 30 * 1024 * 1024){
          const sysMsg = {
            msgtype: "system",
            content: "视频的大小不能超过30M！",
            mid: "native_" + new Date().getTime(),
          };
          showMoreMessage(sysMsg, true);
          return;
        }
        if(utils.isWindowsPC){
          handleVideoBg(file, event, files)
        }else{
          resolveFileInput(event, files, {
            msgtype: "video",
            content: '',
            thumb:'',
            width: 0, 
            height: 0,
            duration: 0,
            size: 0,
            ackid: "msg_" + messageLength++,
          });
        }
      }
    }else{
      resolveFileInput(
        event,
        files,
        {
          msgtype: "file",
          title: file.name,
          size: file.size,
          ackid: "msg_" + messageLength++,
        },
        true
      );
    }
  };
  document.getElementById("textarea").onkeydown = function (e) {
    var ev = document.all ? window.event : e;
    if (ev.keyCode == 13 && !event.shiftKey) {
      event.preventDefault();
      sendTextArea();
    }
  };
  if(utils.isUCBrowser){
    document.getElementById("pic-input").onchange = function (event) {
      resolveSend(event);
    };
    document.getElementById("file-input").onchange = function (event) {
      resolveSend(event);
    };
    document.getElementById("video-btn").onchange = function (event) {
      resolveSend(event);
    };
  }else{
    document.getElementById("pic-input").oninput = function (event) {
      resolveSend(event);
    };
    document.getElementById("file-input").oninput = function (event) {
      resolveSend(event);
    };
    document.getElementById("video-btn").oninput = function (event) {
      resolveSend(event);
    };
  }
  document.getElementById("drop-wrap").ondragover = function (event) {
    event.preventDefault();
    this.classList.add('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "block";
    document.getElementById('msg-wrapper').style.zIndex = -1;
    document.getElementsByClassName('footer')[0].style.zIndex = -1;
  };

  document.getElementById("drop-wrap").ondragleave = function (event) {
    event.preventDefault();
    this.classList.remove('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "none";
  };

  document.getElementById("drop-wrap").onmouseover = function (event) {
    document.getElementById('msg-wrapper').style.zIndex = '';
    document.getElementsByClassName("footer")[0].style.zIndex = '';
  };

  document.getElementById("drop-wrap").ondrop = function (event) {
    event.preventDefault();
    this.classList.remove('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "none";
    document.getElementById('msg-wrapper').style.zIndex = '';
    document.getElementsByClassName("footer")[0].style.zIndex = '';
    const { files } = event.dataTransfer;
    let count = 0;
    for (const i in files) {
      if (typeof files[i] !== 'object') {
        continue;
      }
      count++;
      const file = files[i];

      if(utils.isImageFile(file.name)){
        resolveFileInput(event, files, {
          content: pic_uploading,
          msgtype: "image",
          ackid: "msg_" + messageLength++,
        });
      }else if(utils.isVideoFile(file.name)){
        // 处理视频发送
        if (file) {
          if(file.size > 30 * 1024 * 1024){
            const sysMsg = {
              msgtype: "system",
              content: "视频的大小不能超过30M！",
              mid: "native_" + new Date().getTime(),
            };
            showMoreMessage(sysMsg, true);
            return;
          }
          if(utils.isWindowsPC){
            handleVideoBg(file, event, files)
          }else{
            resolveFileInput(event, files, {
              msgtype: "video",
              content: '',
              thumb:'',
              width: 0, 
              height: 0,
              duration: 0,
              size:'',
              ackid: "msg_" + messageLength++,
            });
          }
        }
      }else{
        resolveFileInput(
          event,
          files,
          {
            msgtype: "file",
            title: file.name,
            size: file.size,
            ackid: "msg_" + messageLength++,
          },
          true
        );
      }
      if (count === 5) {
        return;
      }
    }
  };
  document.addEventListener("paste", (event) => {
    // https://www.jb51.net/article/80657.htm
    if (event.clipboardData || event.originalEvent) {
      //not for ie11  某些chrome版本使用的是event.originalEvent
      var clipboardData =
        event.clipboardData || event.originalEvent.clipboardData;
      if (clipboardData.items) {
        // for chrome
        const items = clipboardData.items;
        let blob;
        //在items里找粘贴的image,据上面分析,需要循环
        for (var i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            //getAsFile() 此方法只是living standard firefox ie11 并不支持
            blob = items[i].getAsFile();
          }
        }
        if (blob) {
          event.preventDefault();

          let file = event.clipboardData.files[0];
          if (window.FileReader) {
            const reader = new FileReader();
            reader.readAsDataURL(file); //必须加此项 否则onload无法执行
            reader.onload = (event) => {
              // event.target.result 即为图片的Base64编码字符串
              const imgData = event.target.result;
              utils.changePromoteDialog({
                content: `<img style="max-height:24rem; max-width:100%"  src=${imgData} />`,
                cb: function () {
                  resolveFileInput(
                    event,
                    { blob: blob },
                    {
                      content: pic_uploading,
                      msgtype: "image",
                      ackid: "msg_" + messageLength++,
                    },
                    false,
                    true
                  );
                },
              });
            };
          }else{ //不支持FileReader 的粘贴直接发出
            resolveFileInput(
              event,
              { blob: blob },
              {
                content: pic_uploading,
                msgtype: "image",
                ackid: "msg_" + messageLength++,
              },
              false,
              true
            );
          }
        }
      }
    }
  });

};

const messageReceived = (data) => {
  const html = createMessageHtml(data, { createNode: true });
  const element = document.getElementById("msg-wrapper");
  element.appendChild(html);
  utils.scrollDownEnd();
  startNotification(data);
};

const startNotification = (data) => {
  const iFrameState = shelltool.getifameState();
  if (loginData.config_data.notify_style == "auto_expand") {
    if (data.from_uid == data.uid) {
      return;
    }
    shelltool.postMessage({ type: "spread" });
    shelltool.setiFrameState(0);
  } else if (!iFrameState) {
    shelltool.postMessage({ type: "redDot" });
  }
  if (!loginData.config_data.notify_is_voice) {
    return;
  }
  let visibile = document.visibilityState;
  if (visibile == undefined) {
    visibile = document.webkitHidden;
  }
  if (visibile == undefined) {
    visibile = document.hidden;
  }
  if (visibile == "visible" && iFrameState) {
    return;
  }
  const audio = document.getElementById("audio") || document.querySelector("audio");
  if (utils.IsIOS) {
    // 处理IOS上音频播放报错问题
    audio.onclick = function () {
      audio.play();
    };
    audio.click();
  } else {
    audio.onclick = function () {
      audio.play();
    };
  }
};

const resolveLogin = (cb) => {
  delete urlParams.t;
  urlParams.version = "0.0.9";
  urlParams.adddomain = true;
  ajaxUtils.httpRequest({
    url: '/wykf/api/v1/enterprise/webplugin/newlogin',
    data: urlParams,
    success:  (result) => {
      const data = result.data;
      loginData.token = data.token;
      loginData.config_data = handleOrginalData(data.config_data);      
      loginData.kefu_name_from =
        loginData.config_data[
          utils.IsPcMode ? "kefu_name" : "mobile_kefu_name"
        ];
      document.getElementById("profile").innerHTML = utils.replaceAll(
        loginData.config_data.customized_info,
        "<p></p>",
        "<p><br/></p>"
      );
      shelltool.postMessage(
        { type: "showBtn", data: loginData.config_data },
        100
      );
      window.requestHis = false
      cb();
    },
  });
};

// 把新接口数据转化为原始数据
const handleOrginalData = function(configData){
    let {pc , mobile, notify } = configData;    
    let data = {
      button_color: pc.menubar.button_style.color,
      button_content: pc.menubar.buttons,
      button_position: pc.menubar.button_style.horizontal,
      button_style: pc.menubar.button_style.shape,        
      vertical: pc.menubar.button_style.vertical,        
      
      customized_info: pc.chatbox.window_config.right_sidebar_content,         
      title: pc.chatbox.window_config.title,
      form_color: pc.chatbox.window_style.color,
      form_position: pc.chatbox.window_style.horizontal,
      form_style: pc.chatbox.type == 1 ? 'customized' : 'normal',
      head_img: pc.chatbox.window_config.avatar,
      kefu_name: pc.chatbox.window_config.nickname,
      show_enable_ad: pc.chatbox.window_config.enable_ad,

      mobile_button_color: mobile.menubar.button_style.color,
      mobile_button_content: mobile.menubar.buttons,
      mobile_button_position: mobile.menubar.button_style.horizontal,
      mobile_button_style: mobile.menubar.button_style.shape,     
      mobile_vertical: mobile.menubar.button_style.vertical,     

      mobile_form_color: mobile.chatbox.window_style.color,
      mobile_form_style: mobile.chatbox.type == 1 ? 'full_screen' : 'half_screen',     
      mobile_head_img: mobile.chatbox.window_config.avatar,
      mobile_kefu_name: mobile.chatbox.window_config.nickname,
      mobile_title: mobile.chatbox.window_config.title,
      mobile_show_enable_ad: mobile.chatbox.window_config.enable_ad,  
      
      notify_is_voice: notify.open_voice,
      notify_style: notify.style,
    }

    //兼容旧数据
    if(typeof(data.button_content) == 'string' || !data.button_content){
      data.button_content = [{
        type: 'chatbox',
        title: data.button_content || '客服在线，点击咨询',
        icon_source_type: 0,
        icon_img_url: '',
        status: 1,
        system_icon_type: 0,
      }]
    }

    if(typeof(data.mobile_button_content) == 'string' || !data.mobile_button_content){
      data.button_content = [{
        type: 'chatbox',
        title: data.button_content || '客服在线，点击咨询',
        icon_source_type: 0,
        icon_img_url: '',
        status: 1,
        system_icon_type: 0,
      }]
    }

    if(data.button_position == 'rightCenter'){
      data.button_position = 'right';
      data.vertical = '50%';
    }
    if(data.button_position == 'leftCenter'){
      data.button_position = 'left';
      data.vertical = '50%';
    }
    if(data.mobile_button_position == 'rightCenter'){
      data.mobile_button_position = 'right';
      data.mobile_vertical = '50%';
    }

    if(data.mobile_button_position == 'leftCenter'){
      data.mobile_button_position = 'left';
      data.mobile_vertical = '50%';
    }  
    return data;   
}
const initContents = () => {
  const config_data = loginData.config_data;
  const pcMode = utils.IsPcMode;
  const titleNode = document.getElementsByClassName("agent-info")[0];
  titleNode.innerHTML = config_data[pcMode ? "title" : "mobile_title"] || "";
  const headImgNode = document.getElementsByClassName("agent-avatar")[0];
  const headImgSrc = config_data[pcMode ? "head_img" : "mobile_head_img"];
  const headAdShow = config_data[pcMode ? "show_enable_ad" : "mobile_show_enable_ad"];
  if (headImgSrc) {
    headImgNode.src = headImgSrc;
    headImgNode.style.display = "block";
  } else {
    titleNode.style.marginLeft = "16px";
  }
  const zhiniAdNode = document.getElementsByClassName("agent-advertise")[0];
  if(Number(headAdShow) === 0){
    if(pcMode){
      titleNode.style.height = '60px';
      titleNode.style.lineHeight = '60px';
      zhiniAdNode.style.display = 'none';
    }else{
      titleNode.style.height = '60px';
      titleNode.style.lineHeight = '60px';
      zhiniAdNode.style.display = 'none';
    }
    
  }
};

const initStyles = () => {
  const config_data = loginData.config_data;
  const styleNode = document.createElement("style");
  styleNode.setAttribute("type", "text/css");
  const formColor =
    config_data[utils.IsPcMode ? "form_color" : "mobile_form_color"];
  const styleContent = `.chat-header, .body-left .footer .text-holder #send-btn{background: ${formColor}}
    .message-item.message-right .message-text {color: #fff; background: ${formColor}}
    ${
      config_data.form_style == "normal" || !utils.IsPcMode
        ? ".body-right{display: none}.chat-body{padding-right: 0}"
        : ""
    }`;
  if (styleNode.styleSheet) {
    styleNode.styleSheet.cssText = styleContent;
  } else {
    styleNode.appendChild(document.createTextNode(styleContent));
  }
  document.head.appendChild(styleNode);
};

let messageLength = 0;
let lastMid = "";
const loginData = {};
const urlParams = utils.getAllparams();
const startProcess = (params) => {
  if (params && params.errcode === 10003) {
    wsUtils.startProcess("closeWsPingEvent", params);
  }
  resolveLogin(() => {
    wsUtils.startProcess("init", {
      messageReceived,
      token: loginData.token,
      params,
    });
    initStyles();
    initContents();
    initEmojiFunction();
    initActions();
  });
};
export default {
  startProcess: startProcess,
  showMoreMessage: showMoreMessage,
};


// WEBPACK FOOTER //
// ./src/js/content.js